<template>
    <input ref="input" type="tel" v-model="value" mask="0599 999 9999" maskChar=" " maxlength="13" placeholder="05** *** ****"/>
</template>
<script>
    import { reactive, toRefs, computed } from 'vue';
    import { appData } from '@/helpers/global';

    export default {
        name: "InputTel",
        /*inheritAttrs: false,v-bind="$attrs"*/
        components: {
        },
        props: ["modelValue"],
        emits: ["update:modelValue"],
        setup(props, ctx) {
            const e = reactive({
                value: computed({
                    get() {
                        return props.modelValue;
                    },
                    set(value) {
                        ctx.emit("update:modelValue", value);
                    }
                }),
            });
            return { ...toRefs(e) };
        },
        mounted() {
            appData.fn.phoneInput(this.$refs.input);
        }
    };
</script>
